import { format, parseISO } from "date-fns";
import { Invoice, InvoiceDocumentType, InvoiceStatus } from "@/model/interface/Invoice";

export const INVOICE_DOCUMENT_LABELS: Record<InvoiceDocumentType, string> = {
  INVOICE: "Invoice",
  RECEIPT: "Receipt",
  CREDIT_NOTE: "Credit note",
};

export function invoiceDocumentName(invoice: Pick<Invoice, "documentType" | "number">): string {
  return [INVOICE_DOCUMENT_LABELS[invoice.documentType] ?? "Invoice", invoice.number].filter(Boolean).join(" ");
}

export const INVOICE_STATUS_LABELS: Record<InvoiceStatus, string> = {
  DRAFT: "Draft",
  AWAITING_PAYMENT: "Awaiting payment",
  PAID: "Paid",
  PARTIALLY_REFUNDED: "Partially refunded",
  REFUNDED: "Refunded",
  VOID: "Void",
  FAILED: "Failed",
};

export const INVOICE_STATUS_PILLS: Record<InvoiceStatus, string> = {
  DRAFT: "status-pill-neutral",
  AWAITING_PAYMENT: "status-pill-warning",
  PAID: "status-pill-success",
  PARTIALLY_REFUNDED: "status-pill-info",
  REFUNDED: "status-pill-info",
  VOID: "status-pill-neutral",
  FAILED: "status-pill-destructive",
};

export const BILLING_STATE_CODES = [
  "AL", "AK", "AZ", "AR", "CA", "CO", "CT", "DE", "DC", "FL",
  "GA", "HI", "ID", "IL", "IN", "IA", "KS", "KY", "LA", "ME",
  "MD", "MA", "MI", "MN", "MS", "MO", "MT", "NE", "NV", "NH",
  "NJ", "NM", "NY", "NC", "ND", "OH", "OK", "OR", "PA", "RI",
  "SC", "SD", "TN", "TX", "UT", "VT", "VA", "WA", "WV", "WI", "WY",
];

const currencyFormatter = new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" });

export function formatInvoiceMoney(amount?: number | null): string {
  return currencyFormatter.format(amount ?? 0);
}

export function formatInvoiceDate(value?: string | null): string {
  if (!value) {
    return "";
  }
  return format(parseISO(value), "MMM d, yyyy");
}

export function formatInvoicePeriod(start?: string | null, end?: string | null): string {
  if (!start || !end) {
    return "";
  }
  return `${format(parseISO(start), "MMM d")} to ${format(parseISO(end), "MMM d, yyyy")}`;
}

export function formatInvoiceQuantity(quantity?: number | null, unit?: string | null): string {
  if (quantity === null || quantity === undefined) {
    return "";
  }
  const number = quantity.toLocaleString("en-US", { maximumFractionDigits: 2 });
  if (!unit) {
    return number;
  }
  const label = quantity === 1 || unit === "min" ? unit : `${unit}s`;
  return `${number} ${label}`;
}
